window.LaxReady(($) => {
  console.log('Init Block: Filmstrip');

  window.lax.addElements('.lax-filmstrip', {
    scrollY: {
      transform: [
        ['elInY', 'elOutY'],
        [0, 100],
        {
          cssFn: (val, el) => {
            el.style.setProperty('--lax_delta', (val / 100));
            return '';
          },
        },
      ],
    },
  });

});